<template>
  <patient-profile>
    <modal-dialog-prevent-leave
      v-bind:is-shown="isShownDialogLeaveConfirm"
      v-bind:title="'Пожалуйста, дождитесь выполнения операций'"
      v-bind:confirm-button-title="'ОК'"
      v-bind:show-leave-button="false"
      v-on:back="isShownDialogLeaveConfirm = false"
      v-on:save="confirmAttention"
    />
    <mobile-fixed-bottom-popup
      v-if="shownWorkOnPCMobilePopup"
      v-on:close="onCloseWorkOnPCMobileAppPopup"
    >
      Совет. Работать в программе удобнее с компьютера.
    </mobile-fixed-bottom-popup>
    <div v-if="isLoading">Загрузка</div>
    <template v-else>
      <patient-paid-stats
        v-bind:advance="patientPayments.advance"
        v-bind:debt="patientPayments.debt"
        v-bind:is-await-recharge="isAwaitCommandExecuted"
        v-bind:paid="patientPayments.paid"
        v-on:advance-details-open="onAdvanceDetailsOpen"
        v-on:open-recharge-form="onOpenAdvanceRechargeForm"
        v-on:withdrawal-open="onOpenAdvanceWithdrawalForm"
        v-on:print-act="onPrintAct"
      />
      <div class="form-invoice__control">
        <div>
          <dl class="form-invoice__control__employee">
            <dt>Сотрудник:</dt>
            <input-autocomplete
              attach
              class="form-invoice__employee__select"
              hide-details
              option-title-key="name"
              option-value-key="id"
              placeholder="Выберите врача"
              required="required"
              title=""
              v-bind:disabled="disableInvoiceChange || disableDoctorChange"
              v-bind:options="allEmployees"
              v-model="selectedEmployeeId"
            />
          </dl>
          <div class="form-invoice__control__row">
            <div class="form-invoice__control__text">{{ title }}</div>
            <router-link
              v-if="hasVisit"
              class="form-invoice__control__visit"
              v-bind:to="{ name: 'ClinicPanelPatientVisit', params: { id: patientId, visitId: visit.id } }"
            >Визит от {{ visit.date }}</router-link>
          </div>
        </div>
        <div class="form-invoice__control__comment">
          <div class="form-invoice__control__comment__description">Комментарий: </div>
          <div
            class="form-invoice__control__comment__input"
          >
            <v-textarea
              v-bind:disabled="isBranch"
              v-on:change="onUpdateInvoiceComment()"
              :maxlength="1000"
              v-model="invoiceComment"
              rows="1"
              auto-grow
              hide-details
            />
            <p
              class="text__violation"
              role="alert"
              v-for="error in commentViolations"
              v-bind:key="error"
            >
              {{ error }}
            </p>
          </div>
        </div>
      </div>
      <form-invoice
        ref="formInvoice"
        v-bind:columns="tableColumns"
        v-bind:column-settings="tableColumnSettings"
        v-bind:disabled="disableInvoiceChange"
        v-bind:initial-discount-type="discountType"
        v-bind:initial-positions="positions"
        v-bind:input-errors="inputErrors"
        v-bind:paid="paid"
        v-bind:payment-advance="paymentDetails.advance"
        v-bind:payment-cash="paymentDetails.cash"
        v-bind:payment-cashless="paymentDetails.cashless"
        v-bind:services="allServices"
        v-on:change-column-settings="onChangeColumnSettings($options.tableId, $event)"
        v-on:change-position="onChangePosition"
        v-on:input-discount-type="onInputDiscountType"
        v-on:remove-position="onRemovePosition"
        v-on:select-cashbox="onSelectCashbox"
        v-on:submit="onSubmit"
      >
        <template v-slot:buttons>
          <div class="form-invoice__form-buttons">
            <button
              v-if="hasPrintInvoiceAct"
              class="form-invoice__buttons-blue"
              type="button"
              v-on:click="onShowPrintActDialog"
            >
              Акт
            </button>
            <button
              class="form-invoice__buttons-blue"
              type="button"
              v-bind:disabled="disabledRefund"
              v-on:click="onPreRefund"
              v-bind:title="paymentButtonTitle"
            >
              Возврат
            </button>
            <button
              v-if="canForcePayment"
              class="form-invoice__buttons-blue"
              type="button"
              v-bind:disabled="isAwaitForcePayment"
              v-on:click="onForcePayment"
            >
              Провести оплату
            </button>
            <button
              class="form-invoice__buttons-blue"
              type="button"
              v-bind:disabled="disabledPayment"
              v-on:click="onPrepayPayment"
              v-bind:title="paymentButtonTitle"
            >
              Оплатить
            </button>
            <button
              v-if="isShowSaveButton"
              v-bind:disabled="isDisabledSaveButton"
              class="form-invoice__buttons-blue"
              type="submit"
            >
              Сохранить
            </button>
          </div>
        </template>
      </form-invoice>
      <div class="patient-profile__table-wrapper">
        <table
          class="operations-table"
          v-if="hasInvoiceOperations"
        >
          <caption class="operations-table__caption">Операции по счету</caption>
          <thead class="operations-table__head">
            <tr>
              <th
                class="operations-table__cell"
                v-bind:key="`operations-head:cells:${cellIndex}`"
                v-for="(title, cellIndex) in operationList.columns"
              >{{ title }}</th>
              <th
                class="operations-table__cell actions"
                key="operations-head:cells:actions"
              >Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="operations-table__body-row"
              v-bind:key="`operations-body:rows:${rowIndex}`"
              v-for="({ actions, cells, id }, rowIndex) in operationList.rows"
            >
              <td
                class="operations-table__cell"
                v-bind:key="`operations-body:rows:${rowIndex}:cells:${cellIndex}`"
                v-for="(title, cellIndex) in cells"
              >{{ title }}</td>
              <td
                class="operations-table__cell actions"
                v-bind:key="`operations-body:rows:${rowIndex}:cells:actions`"
              >
                <button
                  v-bind:disabled="isBranch"
                  class="payment-mode-change"
                  title="Изменить способ оплаты"
                  type="button"
                  v-if="actions.includes('payment-mode-changing')"
                  v-on:click="onChangePaymentModeForInvoiceOperation(id)"
                >Изменить способ оплаты</button>
                <button
                  v-if="actions.includes('print-payment-slip')"
                  class="payment-slip-print"
                  title="Распечатать квитанцию об оплате"
                  type="button"
                  v-on:click="onPrintPaymentSlip(id)"
                >Распечатать квитанцию об оплате</button>
                <button
                  v-if="actions.includes('print-refund-slip')"
                  class="payment-slip-print"
                  title="Распечатать квитанцию о возврате"
                  type="button"
                  v-on:click="onPrintRefundSlip(id)"
                >Распечатать квитанцию о возврате</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <side-slide-transition>
      <side-dialog
        v-click-outside="onClickOutside"
        v-on:cancel="onPaymentCancel"
        v-if="isShownPaymentForm"
        label="Оплата услуг"
      >
        <form-invoice-payment
          v-bind:available-advance="availableAdvance"
          v-bind:cashbox-list="cashboxListPayment"
          v-bind:debt="debt"
          v-bind:amount-to-paid="paymentAmountToPaid"
          v-bind:invoice-id="invoiceId"
          v-bind:is-await-request="isAwaitRequest"
          v-bind:is-await-shift-opened="isCashboxAwaitShiftOpened"
          v-bind:selected-cashbox-id="selectedCashboxId"
          v-bind:selected-position-ids="selectedPositionIds"
          v-bind:is-shift-opened="isCashboxShiftOpened"
          v-on:cancel="onPaymentCancel"
          v-on:select-cashbox="onSelectCashbox"
          v-on:shown-confirm-dialog="onShownConfirmDialog"
          v-on:submit="onPay"
        />
      </side-dialog>
      <side-dialog
        v-on:cancel="onRefundCancel"
        v-if="isShownRefundForm"
        label="Возврат услуг"
      >
        <form-invoice-refund
          v-bind:cashbox-list="cashboxList"
          v-bind:refund-amount="selectedAmountRefund"
          v-bind:refund-types="refundTypes"
          v-bind:invoice-id="invoiceId"
          v-bind:is-await-request="isAwaitRequest"
          v-bind:selected-cashbox-id="selectedCashboxId"
          v-bind:selected-positions="selectedPositionRefund"
          v-on:cancel="onRefundCancel"
          v-on:select-cashbox="onSelectCashbox"
          v-on:submit="onRefund"
        />
      </side-dialog>
      <side-dialog
        v-on:cancel="onCloseAdvanceRechargeForm"
        v-if="isShownAdvanceRechargeForm"
        label="Пополнение"
      >
        <form-advance-recharge
          v-bind:cashbox-list="cashboxList"
          v-bind:is-await-request="isAwaitAdvanceRechargeRequest"
          v-bind:patient-id="patientId"
          v-on:cancel="onCloseAdvanceRechargeForm"
          v-on:submit="onAdvanceRechargeSubmit"
        />
      </side-dialog>
    </side-slide-transition>
    <open-shift-modal-dialog
      v-bind:is-await-request="isAwaitShiftRequest"
      v-bind:value="isShowShiftOpenDialog"
      v-on:input="onCloseShiftDialog"
      v-on:submit="onOpenShift"
    />
    <modal-dialog with-cross persistent v-model="showPrintActDialog" title="Выберите действие">
      <template>
        <div class="invoice__document">
          <label class="invoice__document__count">
            <span>№ </span>
            <input
              aria-label="Ввод номера"
              type="number"
              v-bind:min="1"
              v-model="actDocumentNumber"
            />
          </label>
          <div class="invoice__document__date">
            <span>от</span>
            <input
              type="date"
              v-model="actDocumentDate"
            />
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <div class="invoice__document__buttons">
          <button
            class="invoice__document__button"
            type="button"
            v-bind:disabled="isFormButtonDisabled"
            v-on:click="onPrintInvoiceAct"
          >Печать</button>
          <button
            class="invoice__document__button"
            type="button"
            v-bind:disabled="isFormButtonDisabled"
            v-on:click="onDownloadInvoiceAct"
          >Скачать</button>
        </div>
      </template>
    </modal-dialog>
    <modal-dialog
      title="Списание аванса"
      v-model="shownPrepayDialog"
      with-cross
      persistent>
      <div class="invoice__prepay-dialog">
        <span>Долг:</span><the-rub v-bind:kop="invoiceDebt" currency="руб." />
        <span>Доступный аванс:</span><the-rub v-bind:kop="availableAdvance" currency="руб." />
        <span>Сумма:</span><price-input v-model="prepayAmount" v-bind:max="maxAmountForPrepay" />
      </div>
      <template v-slot:actions>
        <div class="invoice__prepay-dialog__buttons">
          <button
            class="invoice__prepay-dialog__button-cancel"
            type="button"
            v-on:click="shownPrepayDialog = false">Отмена</button>
          <button
            class="invoice__prepay-dialog__button-submit"
            v-bind:disabled="isDisabledPrepayButtonSubmit"
            type="button"
            v-on:click="onPrepay">Внести</button>
        </div>
      </template>
    </modal-dialog>
    <modal-dialog
      v-model="isShownPositionSelectDialog"
      v-bind:title="dialogTitle"
      with-cross
      scrollable
    >
      <template v-slot:actions>
        <div v-if="isShownPositionsForPayment" class="form-select__buttons">
          <button
            class="form-select__button-cancel"
            type="button"
            v-on:click="isShownPositionSelectDialog = false"
          >Отмена</button>
          <button
            class="form-select__button-submit"
            type="button"
            v-bind:disabled="isContinueButtonDisabled"
            v-bind:title="continueButtonTitle"
            v-on:click="prepareSelectedPositionsForPayment"
          >Продолжить</button>
        </div>
      </template>
      <form
        v-if="isShownPositionsForPayment"
        class="form-select"
        v-on:submit.prevent="prepareSelectedPositionsForPayment"
      >
        <div class="form-select__table">
          <div class="form-select__table__head">
            <div class="form-select__table__cell" />
            <div class="form-select__table__cell">Услуга</div>
            <div class="form-select__table__cell">Цена</div>
            <div class="form-select__table__cell">Кол-во</div>
            <div class="form-select__table__cell">Скидка</div>
            <div class="form-select__table__cell">Рекламация</div>
            <div class="form-select__table__cell">К оплате</div>
          </div>
          <div class="form-select__table__body">
            <div
              class="form-select__table__row"
              v-bind:key="position.id"
              v-for="{ isSelected, position } in positionsForPayments"
            >
              <input-checkbox
                data-label="Выбрать"
                class="form-select__table__cell checkbox"
                v-bind:value="isSelected"
                v-on:input="onSelectPositionForPayment(position, $event)"
              />
              <div
                class="form-select__table__cell"
                data-label="Услуга"
                v-bind:title="position.categoryName"
              >
                {{ position.serviceName }}
              </div>
              <the-rub
                class="form-select__table__cell"
                currency="руб"
                data-label="Цена"
                show-kop="auto"
                v-bind:kop="position.cost"
              />
              <div
                class="form-select__table__cell"
                data-label="Кол-во"
              >
                {{ position.count }}
              </div>
              <div
                v-if="position.discount.type === $options.percentDiscountType"
                class="form-select__table__cell"
                data-label="Скидка"
              >
                {{ position.discount.value }}%
              </div>
              <the-rub
                v-else
                class="form-select__table__cell"
                currency="руб"
                data-label="Скидка"
                show-kop="auto"
                v-bind:kop="position.discount.value"
              />
              <input-checkbox
                class="form-select__table__cell checkbox"
                data-label="Рекламация"
                disabled
                v-bind:value="position.complaint"
              />
              <the-rub
                class="form-select__table__cell"
                currency="руб"
                data-label="К оплате"
                show-kop="auto"
                v-bind:kop="position.debt"
              />
            </div>
          </div>
        </div>
        <div class="form-select__sum">
          Итого к оплате: <the-rub
            v-bind:kop="selectedAmount"
            currency="руб"
            show-kop="auto"
          />
        </div>
        <div class="form-select__sum">
          Внести:
          <div class="form-select__sum-wrapper">
            <price-input
              class="form-select__sum__field"
              v-bind:max="selectedAmount"
              v-bind:with-currency="false"
              v-model="paymentAmountToPaid"
            />
            <span>руб</span>
          </div>
        </div>
        <div class="form-select__sum">
          Долг: <the-rub
            v-bind:kop="debtAfterPaid"
            currency="руб"
            show-kop="auto"
          />
        </div>
      </form>
      <div v-else class="form-select__buttons">
        <button
          class="form-select__button-submit"
          type="button"
          v-on:click="onPayAllPosition">Оплатить все услуги</button>
        <button
          class="form-select__button-submit"
          type="button"
          v-on:click="showPositionsForPayment">Частичная оплата</button>
      </div>
    </modal-dialog>
    <modal-dialog
      v-model="isShownPositionRefundSelectDialog"
      v-bind:title="dialogRefundTitle"
      with-cross
      scrollable
    >
      <template v-slot:actions>
        <div v-if="isShownPositionsForRefund" class="form-select__buttons">
          <button
            class="form-select__button-cancel"
            type="button"
            v-on:click="isShownPositionRefundSelectDialog = false"
          >Отмена</button>
          <button
            class="form-select__button-submit"
            type="button"
            v-bind:disabled="isContinueRefundButtonDisabled"
            v-bind:title="continueRefundButtonTitle"
            v-on:click="prepareSelectedPositionsForRefund"
          >Продолжить</button>
        </div>
      </template>
      <form
        v-if="isShownPositionsForRefund"
        class="form-select"
        v-on:submit.prevent="prepareSelectedPositionsForRefund"
      >
        <div class="form-select__table">
          <div class="form-select__table__head">
            <div class="form-select__table__cell" />
            <div class="form-select__table__cell">Услуга</div>
            <div class="form-select__table__cell">Цена</div>
            <div class="form-select__table__cell">Кол-во</div>
            <div class="form-select__table__cell">Скидка</div>
            <div class="form-select__table__cell">Возврат</div>
          </div>
          <div class="form-select__table__body">
            <div
              class="form-select__table__row"
              v-bind:key="position.id"
              v-for="{ isSelected, position } in positionsForRefund"
            >
              <input-checkbox
                data-label="Выбрать"
                class="form-select__table__cell checkbox"
                v-bind:value="isSelected"
                v-on:input="onSelectPositionForRefund(position, $event)"
              />
              <div
                class="form-select__table__cell"
                data-label="Услуга"
                v-bind:title="position.categoryName"
              >
                {{ position.serviceName }}
              </div>
              <the-rub
                class="form-select__table__cell"
                currency="руб"
                data-label="Цена"
                show-kop="auto"
                v-bind:kop="position.cost"
              />
              <input-number
                class="form-select__table__cell"
                v-model="position.count"
                v-bind:max="position.maxCount"
                min="1"
                v-on:input="onInputPositionCountForRefund"
              />
              <div
                v-if="position.discount.type === $options.percentDiscountType"
                class="form-select__table__cell"
                data-label="Скидка"
              >
                {{ position.discount.value }}%
              </div>
              <the-rub
                v-else
                class="form-select__table__cell"
                currency="руб"
                data-label="Скидка"
                show-kop="auto"
                v-bind:kop="position.discount.value"
              />
              <the-rub
                class="form-select__table__cell"
                currency="руб"
                data-label="К возврату"
                show-kop="auto"
                v-bind:kop="position.amount"
              />
            </div>
          </div>
        </div>
        <div class="form-select__sum">
          Итого:
          <div class="form-select__sum-wrapper">
            <price-input
              class="form-select__sum__field"
              v-bind:max="maxSelectedAmountRefund"
              v-bind:with-currency="false"
              v-model="selectedAmountRefund"
            />
            <span>руб</span>
          </div>
        </div>
      </form>
      <div v-else class="form-select__buttons">
        <button
          class="form-select__button-submit"
          type="button"
          v-on:click="onRefundAllPosition">Возврат по всем услугам</button>
        <button
          class="form-select__button-submit"
          type="button"
          v-on:click="showPositionsForRefund">Частичный возврат</button>
      </div>
    </modal-dialog>
    <iframe
      class="invoice__print"
      ref="printView"
      title="printView"
    />
    <modal-dialog
      title="Изменить способ оплаты"
      v-bind:value="isShownChangePaymentModeForInvoiceOperationDialog"
      v-on:input="onCancelChangePaymentModeForInvoiceOperation"
      with-cross
    >
      <form-payment-mode-change
        v-if="isShownChangePaymentModeForInvoiceOperationDialog"
        v-bind:initial-mode="paymentOperationForChangeMode.mode"
        v-bind:mode-options="availablePaymentModesForChanging"
        v-bind:total-paid="paymentOperationForChangeMode.totalPaid"
        v-on:cancel="onCancelChangePaymentModeForInvoiceOperation(false)"
        v-on:submit="onSubmitChangePaymentModeForInvoiceOperation"
      />
    </modal-dialog>
    <modal-dialog
      title="Изменить способ пополнения аванса"
      v-bind:value="isShownChangePaymentModeForAdvanceRechargeOperationDialog"
      v-on:input="onCancelChangePaymentModeForAdvanceRechargeOperation"
      with-cross
    >
      <form-payment-mode-change
        v-if="isShownChangePaymentModeForAdvanceRechargeOperationDialog"
        v-bind:initial-mode="rechargeOperationForChangeMode.mode"
        v-bind:mode-options="availablePaymentModesForRechargeOperationChanging"
        v-bind:total-paid="rechargeOperationForChangeMode.totalPaid"
        v-on:cancel="onCancelChangePaymentModeForAdvanceRechargeOperation(false)"
        v-on:submit="onSubmitChangePaymentModeForAdvanceRechargeOperation"
      />
    </modal-dialog>
    <modal-dialog
      title="Детализация аванса"
      v-bind:value="hasAdvanceDetails"
      v-on:input="onAdvanceDetailsCancel"
      with-cross
    >
      <table-advance-details
        v-if="hasAdvanceDetails"
        v-bind:invoice-id="$route.params.invoiceId"
        v-bind="advanceDetails"
        v-on:change-payment-mode="onChangePaymentModeFromAdvanceRechargeOperation" />
    </modal-dialog>
    <side-slide-transition>
      <side-dialog
        class="form-advance-withdrawal-dialog"
        v-on:cancel="onCloseAdvanceWithdrawalForm"
        v-if="hasAdvanceForWithdrawal"
        label="Списание аванса"
      >
        <form-advance-withdrawal
          class="form-advance-withdrawal-dialog__body"
          v-bind:is-await-request="isAwaitAdvanceWithdrawalRequest"
          v-bind:cashbox-list="cashboxListForWithdrawal"
          v-on:submit="onAdvanceWithdrawalSubmit"
        />
      </side-dialog>
    </side-slide-transition>
  </patient-profile>
</template>

<script>
import advanceRechargeMixin from '@/mixins/advanceRechargeMixin';
import notifierMixin from '@/mixins/notifierMixin';
import invoiceMixin from '@/mixins/invoiceMixin';
import { EditRequest, PrepayRequest, SetInvoiceCommentRequest } from '@/storage/gateways/InvoiceGateway';
import { Maybe } from 'monet';
import FormAdvanceRecharge from '@/components/FormAdvanceRecharge.vue';
import FormAdvanceWithdrawal from '@/components/FormAdvanceWithdrawal.vue';
import FormPaymentModeChange from '@/components/FormPaymentModeChange.vue';
import FormInvoice from '@/components/FormInvoice.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import FormInvoicePayment from '@/components/FormInvoicePayment.vue';
import SideDialog from '@/components/SideDialog.vue';
import onlineCheckMixin, { STATUS_FAIL } from '@/mixins/onlineCheckMixin';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import InputAutocomplete from '@/components/InputAutocomplete.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import PriceInput from '@/components/PriceInput.vue';
import TheRub from '@/components/TheRub.vue';
import shiftMixin from '@/mixins/shiftMixin';
import OpenShiftModalDialog from '@/components/OpenShiftModalDialog.vue';
import preventLeaveWithoutConfirmMixin from '@/mixins/preventLeaveWithoutConfirmMixin';
import ModalDialogPreventLeave from '@/components/ModalDialogPreventLeave.vue';
import { DISCOUNT_IN_PERCENT, DISCOUNT_MIXED } from '@/components/SwitchDiscountType.vue';
import PatientPaidStats from '@/components/PatientPaidStats.vue';
import InputCheckbox from '@/components/InputCheckbox.vue';
import ServicePriceRubles from '@/storage/ServicePriceRubles';
import TableAdvanceDetails from '@/components/TableAdvanceDetails.vue';
import FormInvoiceRefund from '@/components/FormInvoiceRefund.vue';
import MobileFixedBottomPopup from '@/components/MobileFixedBottomPopup.vue';
import mobilePopupMixin from '@/mixins/mobilePopupMixin';
import mobileMixin from '@/mixins/mobileMixin';
import advanceWithdrawMixin from '@/mixins/advanceWithdrawMixin';
import customizableTableMixin from '@/mixins/customizableTableMixin';
import InputNumber from '@/components/InputNumber.vue';

/**
 * @description Идентификатор действия редактирования счета.
 * @type {string}
 */
const ACTION_INVOICE_CHANGE_ID = 'change';

/**
 * @description Действие проверки состояния смены.
 * @type {string}
 */
const ACTION_CHECK_SHIFT_STATE = 'check-shift-state';

/**
 * @description Действие принудительно провести оплату.
 * @type {string}
 */
const ACTION_FORCE_MAKE_PAYMENT = 'force-make-payment';

/**
 * @description Операция пополнения аванса.
 * @type {string}
 */
const OPERATION_RECHARGE = 'operation-recharge';

/**
 * @description Операция оплаты.
 * @type {string}
 */
const OPERATION_PAY = 'operation-pay';

/**
 * @description Операция возврата.
 * @type {string}
 */
const OPERATION_REFUND = 'operation-refund';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Сохранить файл.
 * @param {any}    file Файл.
 * @param {string} name Название файла.
 */
function saveFile(file, name) {
  const obj = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = obj;
  link.target = '_blank';
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
  link.remove();
}

/**
 * @description Идентификатор документа акта.
 * @type {string}
 */
const ID_ACT = 'act';

/**
 * @description Примесь печати акта.
 * @type {Vue}
 */
const actDocumentPrint = {
  computed: {
    hasPrintInvoiceAct() {
      return this.invoiceDocuments.some((candidate) => candidate.id === ID_ACT);
    },
    isFormButtonDisabled() {
      return !this.actDocumentDate || !this.actDocumentNumber;
    },
  },
  data() {
    return {
      actDocumentDate: '',
      actDocumentNumber: '',
      showPrintActDialog: false,
    };
  },
  methods: {
    onShowPrintActDialog() {
      const document = this.invoiceDocuments.find((candidate) => candidate.id === ID_ACT);
      if (!document) {
        return;
      }
      this.actDocumentDate = document.date;
      this.actDocumentNumber = document.number;
      this.showPrintActDialog = true;
    },
    makeActDocumentRequest() {
      return {
        date: this.actDocumentDate,
        number: this.actDocumentNumber,
      };
    },
    /**
     * @description Скачать акт.
     * @returns {void}
     */
    onDownloadInvoiceAct() {
      const onFail = (error) => this.notifyFail(error.title);
      const onSuccess = (response) => {
        saveFile(response, 'Акт.docx');
      };
      const request = this.makeActDocumentRequest();
      this
        .$invoiceGateway
        .downloadAct(this.invoiceId, request)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Распечатать акт.
     * @returns {void}
     */
    onPrintInvoiceAct() {
      const onFail = (error) => this.notifyFail(error.title);
      const onSuccess = (response) => {
        const blob = new Blob([response], { type: 'text/html' });
        const container = this.$refs.printView;
        container.setAttribute('src', URL.createObjectURL(blob));
        container.onload = () => {
          container.contentWindow.print();
        };
      };
      const request = this.makeActDocumentRequest();
      this
        .$invoiceGateway
        .printAct(this.invoiceId, request)
        .then((result) => result.fold(onFail, onSuccess));
    },
  },
};

const cashboxMixin = {
  computed: {
    isOnlineCheckCashbox() {
      if (!this.selectedCashbox) { return false; }
      return this.selectedCashbox.tags.includes('online-check');
    },
    selectedCashboxId() {
      return this.selectedCashbox ? this.selectedCashbox.id : null;
    },
    isCashboxShiftOpened() {
      if (!this.selectedCashbox) { return false; }
      if (this.isOnlineCheckCashbox) {
        return this.isShiftOpened;
      }
      return true;
    },
    isCashboxAwaitShiftOpened() {
      return this.isOnlineCheckCashbox ? this.isAwaitShiftOpened : false;
    },
  },
  data() {
    return {
      /**
       * @description Список касс.
       * @type {object[]}
       */
      cashboxList: [],
      /**
       * @description Список касс для оплаты.
       * @type {object[]}
       */
      cashboxListPayment: [],
      /**
       * @description Выбранная касса.
       * @type {(object|null)}
       */
      selectedCashbox: null,
    };
  },
  methods: {
    /**
     * @description Получить список касс.
     * @returns {void}
     */
    fetchCashboxesList() {
      const onSuccess = (cashboxes) => {
        this.cashboxList = cashboxes;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$cashboxGateway
        .viewList()
        .then((result) => result.fold(onFail, onSuccess));
    },
    preselectDefaultCashbox(force = false) {
      if (this.selectedCashbox && !force) { return; }
      const defaultCashbox = this.cashboxListPayment.find(
        (candidate) => candidate.tags.includes('default'),
      );
      if (defaultCashbox) {
        this.selectedCashbox = defaultCashbox;
        return;
      }
      this.cashboxListPayment.slice(0, 1).forEach((cashbox) => {
        this.selectedCashbox = cashbox;
      });
    },
    selectOnlineCheckCashbox() {
      const prevSelectedCashboxId = this.selectedCashboxId;
      const setPreviousCashbox = () => {
        if (prevSelectedCashboxId) {
          this.selectedCashbox = this.cashboxList.find(
            (candidate) => candidate.id === prevSelectedCashboxId,
          ) || null;
        } else {
          this.selectedCashbox = null;
        }
      };
      this.awaitShiftOpened().then((isOpened) => {
        if (!isOpened) {
          setPreviousCashbox();
        }
      });
    },
    /**
     * @description Обработать выбор кассы.
     * @param {any} cashbox Касса.
     * @returns {void}
     */
    onSelectCashbox(cashbox) {
      if (!cashbox) {
        this.selectedCashbox = null;
        return;
      }
      if (cashbox.tags.includes('online-check') && !this.isShiftOpened) {
        this.selectOnlineCheckCashbox();
      }
      this.selectedCashbox = cashbox;
    },
  },
};

/**
 * @description Примесь пополнения аванса.
 * @type {object}
 */
const rechargeMixin = {
  methods: {
    /**
     * @description Обработать открытие формы пополнения аванса.
     * @returns {void}
     */
    onOpenAdvanceRechargeForm() {
      this.currentOperation = Maybe.some(OPERATION_RECHARGE);
      if (this.needOpenedShift) {
        this
          .checkShiftIsOpened()
          .then(async (isOpened) => {
            if (isOpened) {
              this.continueOperation();
            }
          });
      } else {
        this.continueOperation();
      }
    },
    /**
     * @description Обработать отправку запроса на пополнение аванса.
     * @param {AdvanceRechargeRequest} request Запрос.
     * @returns {void}
     */
    onAdvanceRechargeSubmit(request) {
      const { invoiceId } = this;
      this
        .sendAdvanceRechargeRequest(request)
        .then((isSuccess) => {
          if (isSuccess) {
            this.fetchInvoice(invoiceId);
          }
        });
    },
  },
  mixins: [advanceRechargeMixin],
};

/**
 * @description Примесь списания аванса.
 * @type {object}
 */
const withdrawalMixin = {
  methods: {
    /**
     * @description Обработать открытие формы пополнения аванса.
     * @returns {void}
     */
    onOpenAdvanceWithdrawalForm() {
      if (this.needOpenedShift) {
        this
          .checkShiftIsOpened()
          .then(async (isOpened) => {
            if (isOpened) {
              this.openAdvanceWithdrawalForm();
            }
          });
      } else {
        this.openAdvanceWithdrawalForm();
      }
    },
    /**
     * @description Обработать отправку запроса на списание аванса.
     * @param {number} cashboxId Идентификатор кассы.
     * @param {string} rubles    Сумма.
     * @returns {void}
     */
    onAdvanceWithdrawalSubmit(cashboxId, rubles) {
      this
        .sendAdvanceWithdrawalRequest(this.patientId, cashboxId, rubles)
        .then((isSuccess) => {
          if (isSuccess) {
            this.fetchInvoice(this.invoiceId);
          }
        });
    },
  },
  mixins: [advanceWithdrawMixin],
};

/**
 * @description Примесь внесения аванса на счет пациента.
 * @type {object}
 */
const prepayMixin = {
  computed: {
    /**
     * @description Деактивировать кнопку внесения аванса.
     * @type {boolean}
     */
    isDisabledPrepayButtonSubmit() {
      return this.prepayAmount === 0 || this.isAwaitRequest;
    },
    /**
     * @description Максимальная сумма для внесения аванса.
     * @type {number}
     */
    maxAmountForPrepay() {
      return this.availableAdvance > this.invoiceDebt ? this.invoiceDebt : this.availableAdvance;
    },
    /**
     * @description Показать диалог внесения аванса.
     * @type {boolean}
     */
    needShownPrepayDialog() {
      return this.$route.params.isNew === true
        && this.availableAdvance > 0
        && this.invoiceDebt > 0
        && this.suggestPrepay;
    },
  },
  data() {
    return {
      /**
       * @description Сумма для внесения аванса.
       * @type {number}
       */
      prepayAmount: 0,
      /**
       * @description Показывать диалог внесения аванса.
       * @type {boolean}
       */
      shownPrepayDialog: false,
      /**
       * @description Предлагать внести аванс.
       * @type {boolean}
       */
      suggestPrepay: true,
    };
  },
  methods: {
    /**
     * @description Обработать внесение аванса на счет.
     * @returns {void}
     */
    onPrepay() {
      const id = this.invoiceId;
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        this.inputErrors = {};
        this.notifySuccess(result);
        this.shownPrepayDialog = false;
        this.fetchInvoice(id);
      };
      const request = new PrepayRequest(id, this.prepayAmount);
      this.isAwaitRequest = true;
      this.$invoiceGateway
        .prepay(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
  },
};

/**
 * @description Примесь выбора позиция для оплаты.
 * @type {object}
 */
const selectPositionForPaidMixin = {
  computed: {
    debtAfterPaid() {
      return this.debt - this.paymentAmountToPaid;
    },
    dialogTitle() {
      return this.isShownPositionsForPayment
        ? 'Выберите позиции'
        : 'Выберите вариант оплаты';
    },
    canSelectPositions() {
      return this.positionsForPaymentList.length > 1;
    },
    positionsForPayments() {
      return this.positionsForPaymentList.map((position) => ({
        position,
        isSelected: this.selectedPositionIds.includes(position.id),
      }));
    },
    /**
     * @description Выбранная сумма для оплаты в копейках.
     * @returns {number}
     */
    selectedAmount() {
      if (this.selectedPositionIds.length > 0) {
        return this
          .positionsForPayments
          .filter(({ isSelected }) => isSelected)
          .reduce(
            (total, { position }) => total + position.debt,
            0,
          );
      }
      return this
        .positionsForPayments
        .reduce(
          (total, { position }) => total + position.debt,
          0,
        );
    },
    isContinueButtonDisabled() {
      return this.selectedAmount === 0;
    },
    continueButtonTitle() {
      return this.isContinueButtonDisabled ? 'Выберите позиции для оплаты' : '';
    },
  },
  data() {
    return {
      positionsForPaymentList: [],
      selectedPositionIds: [],
      isShownPositionSelectDialog: false,
      isShownPositionsForPayment: false,
      selectedAmountForPayment: ServicePriceRubles.zero(),
      paymentAmountToPaid: 0,
    };
  },
  methods: {
    showPositionSelectDialog() {
      this.selectedPositionIds = [];
      this.selectedAmountForPayment = ServicePriceRubles.zero();
      this.isShownPositionsForPayment = false;
      this.isShownPositionSelectDialog = true;
    },
    showPositionsForPayment() {
      this.isShownPositionsForPayment = true;
    },
    onSelectPositionForPayment({ id }, isSelected) {
      const index = this.selectedPositionIds.indexOf(id);
      if (isSelected && index < 0) {
        this.selectedPositionIds.push(id);
      } else if (!isSelected && index >= 0) {
        this.selectedPositionIds.splice(index, 1);
      }
    },
    prepareSelectedPositionsForPayment() {
      this.selectedAmountForPayment = new ServicePriceRubles(this.selectedAmount);
      this.isShownPositionSelectDialog = false;
      this.showPaymentForm();
    },
    onPayAllPosition() {
      this.selectedPositionIds = this.positionsForPaymentList.map(({ id }) => id);
      this.paymentAmountToPaid = this.selectedAmount;
      this.isShownPositionSelectDialog = false;
      this.showPaymentForm();
    },
    /**
     * @description Обработать подготовку к оплате.
     * @returns {void}
     */
    onPrepayPayment() {
      if (this.isOnlineCheckCashbox) {
        this.awaitShiftOpened().then((isOpened) => {
          if (!isOpened) {
            this.selectedCashbox = null;
          }
          this.showPositionSelectDialog();
        });
      } else {
        this.showPositionSelectDialog();
      }
    },
    /**
     * @description Обработать завершение оплаты при оплате выбранных позиций.
     * @returns {void}
     */
    onSelectPositionForPaidPaid() {
      this.selectedAmountForPayment = ServicePriceRubles.zero();
      this.selectedPositionIds = [];
    },
  },
};

/**
 * @description Способы возвратов.
 * @type {any[]}
 */
const REFUND_TYPES = [
  { title: 'Наличными', value: 'cash' },
  { title: 'На аванс', value: 'advance' },
  { title: 'На карту', value: 'cashless' },
];

/**
 * @description Примесь выбора позиция для возврата.
 * @type {object}
 */
const selectPositionForRefundMixin = {
  computed: {
    /**
     * @description Заголовок диалогового окна.
     * @returns {string}
     */
    dialogRefundTitle() {
      return this.isShownPositionsForRefund
        ? 'Выберите позиции'
        : 'Выберите вариант возврата';
    },
    /**
     * @description Позиции на возврат.
     * @returns {{isSelected: *, position: *}[]}
     */
    positionsForRefund() {
      return this.positionsForRefundList
        .map((position) => ({
          position,
          isSelected: this.selectedPositionRefundIds.includes(position.id),
        }));
    },
    /**
     * @description Кнопка продолжения возврата отключена.
     * @returns {boolean}
     */
    isContinueRefundButtonDisabled() {
      return this.selectedAmountRefund === 0;
    },
    /**
     * @description Заголовок название кнопки продолжения возврата.
     * @returns {string}
     */
    continueRefundButtonTitle() {
      return this.isContinueRefundButtonDisabled ? 'Выберите позиции для возврата' : '';
    },
    refundTypes() {
      if (!this.selectedCashbox) {
        return [];
      }
      return REFUND_TYPES;
    },
    maxSelectedAmountRefund() {
      return this
        .selectedPositionRefund
        .reduce(
          (total, { position }) => total + position.amount,
          0,
        );
    },
    selectedPositionRefund() {
      return this
        .positionsForRefund
        .filter(({ isSelected }) => isSelected);
    },
  },
  data() {
    return {
      initialPositionsForRefundList: [],
      positionsForRefundList: [],
      selectedPositionRefundIds: [],
      isShownPositionRefundSelectDialog: false,
      isShownPositionsForRefund: false,
      selectedAmountForRefund: ServicePriceRubles.zero(),
      selectedAmountRefund: 0,
    };
  },
  methods: {
  /**
     * @description Выбранная сумма для возврата в копейках.
     * @returns {number}
     */
    calcRefundAmount() {
      return this
        .positionsForRefund
        .filter(({ isSelected }) => isSelected)
        .reduce(
          (total, { position }) => {
            const discountKop = position.discount.convertToKop(
              position.cost * position.maxCount,
            ).getValue();
            const discount = discountKop / position.maxCount;
            const amount = Math.ceil(
              ((position.cost * position.count) - (discount * position.count)) / 100,
            ) * 100;
            const finalAmount = amount > position.maxAmount ? position.maxAmount : amount;
            Object.assign(position, { amount: finalAmount });
            return total + finalAmount;
          },
          0,
        );
    },
    onInputPositionCountForRefund() {
      this.selectedAmountRefund = this.calcRefundAmount();
    },
    /**
     * @description Показать диалоговое окно позиций возврата.
     * @returns {void}
     */
    showPositionRefundSelectDialog() {
      this.selectedPositionRefundIds = [];
      this.selectedAmountForRefund = ServicePriceRubles.zero();
      this.isShownPositionsForRefund = false;
      this.isShownPositionRefundSelectDialog = true;
    },
    /**
     * @description Показать позиции для возврата.
     * @returns {void}
     */
    showPositionsForRefund() {
      this.isShownPositionsForRefund = true;
    },
    /**
     * @description Обработать выбор позиции для возврата.
     * @param id
     * @param isSelected
     */
    onSelectPositionForRefund({ id }, isSelected) {
      const index = this.selectedPositionRefundIds.indexOf(id);
      if (isSelected && index < 0) {
        this.selectedPositionRefundIds.push(id);
      } else if (!isSelected && index >= 0) {
        this.selectedPositionRefundIds.splice(index, 1);
      }
      this.selectedAmountRefund = this.calcRefundAmount();
    },
    /**
     * @description Подготовить выбранные позиции для возврата.
     * @returns {void}
     */
    prepareSelectedPositionsForRefund() {
      this.selectedAmountForRefund = new ServicePriceRubles(this.selectedAmountRefund);
      this.isShownPositionRefundSelectDialog = false;
      this.showRefundForm();
    },
    /**
     * @description Обработать возврат всех позиций.
     * @returns {void}
     */
    onRefundAllPosition() {
      this.selectedPositionRefundIds = this.positionsForRefundList.map(({ id }) => id);
      this.selectedAmountRefund = this.calcRefundAmount();
      this.isShownPositionRefundSelectDialog = false;
      this.showRefundForm();
    },
    /**
     * @description Обработать подготовку к возврату.
     * @returns {void}
     */
    onPreRefund() {
      this.positionsForRefundList = this.initialPositionsForRefundList.map((position) => ({
        ...position,
        maxCount: position.count,
        maxAmount: position.amount,
      }));
      this.selectedAmountRefund = 0;
      this.showPositionRefundSelectDialog();
    },
    /**
     * @description Обработать завершение возврата при возврате выбранных позиций.
     * @returns {void}
     */
    onSelectPositionForRefundRefund() {
      this.selectedAmountForRefund = ServicePriceRubles.zero();
      this.selectedPositionRefundIds = [];
    },
  },
};

/**
 * @description Идентификатор таблицы.
 * @type {string}
 */
const TABLE_ID = 'invoice-positions';

/**
 * @description Счет пациента.
 * @type {any}
 */
export default {
  tableId: TABLE_ID,
  percentDiscountType: DISCOUNT_IN_PERCENT,
  components: {
    MobileFixedBottomPopup,
    FormInvoiceRefund,
    FormAdvanceRecharge,
    FormAdvanceWithdrawal,
    FormPaymentModeChange,
    FormInvoice,
    FormInvoicePayment,
    InputAutocomplete,
    ModalDialog,
    ModalDialogPreventLeave,
    OpenShiftModalDialog,
    PatientPaidStats,
    PatientProfile,
    PriceInput,
    SideDialog,
    SideSlideTransition,
    TheRub,
    InputCheckbox,
    TableAdvanceDetails,
    InputNumber,
  },
  computed: {
    /**
     * @description Ошибки для комментария счёта.
     * @return {function}
     */
    commentViolations: resolveInputErrors('invoice-comment'),
    /**
     * @description Оплаты пациента.
     * @type {object}
     */
    patientPayments() {
      return this.invoice.fold({})((invoice) => ({
        advance: invoice.totalAdvance,
        debt: invoice.totalDebt,
        paid: invoice.totalPaid,
      }));
    },
    /**
     * @description Доступный аванс.
     * @type {number}
     */
    availableAdvance() {
      if (!this.selectedCashbox) { return 0; }
      return this.selectedCashbox.advance_balance;
    },
    /**
     * @description Все сотрудники.
     * @type {any[]}
     */
    allEmployees() {
      if (this.employee) {
        return [...this.employees, this.employee];
      }
      return this.employees;
    },
    /**
     * @description Разрешить принудительно провести оплату.
     * @type {boolean}
     */
    canForcePayment() {
      if (!this.paymentCommandId) {
        return false;
      }
      return this.actions.includes(ACTION_FORCE_MAKE_PAYMENT)
        || this.onlineCheckActions.includes(ACTION_FORCE_MAKE_PAYMENT);
    },
    /**
     * @description Деактивировать возможность редактирования счета.
     * @type {boolean}
     */
    disableInvoiceChange() {
      return !this.actions.includes(ACTION_INVOICE_CHANGE_ID);
    },
    /**
     * @description Имеется детализация аванса.
     */
    hasAdvanceDetails() {
      return this.advanceDetails !== null;
    },
    /**
     * @description Имеет аванс для списания.
     */
    hasAdvanceForWithdrawal() {
      return this.advanceForWithdrawal !== null;
    },
    /**
     * @description Имеет операции по счету.
     */
    hasInvoiceOperations() {
      return this.operationList !== null && this.operationList.rows.length !== 0;
    },
    /**
     * @description Долг по счету.
     * @type {number}
     */
    invoiceDebt() {
      return this.invoice.fold(0)(({ debt }) => debt);
    },
    debt() {
      return ServicePriceRubles.zero().less(this.selectedAmountForPayment)
        ? this.selectedAmountForPayment.toKop()
        : this.invoiceDebt;
    },
    /**
     * @description Идентификатор счета.
     * @type {number}
     */
    invoiceId() {
      return +this.$route.params.invoiceId;
    },
    /**
     * @description Счет изменен.
     * @type {boolean}
     */
    isChanged() {
      return this.isEmployeeChanged || this.isPositionsChanged;
    },
    /**
     * @description Деактивировать кнопку сохранения счета
     * @return {boolean}
     */
    isDisabledSaveButton() {
      return (!this.positions.length && this.isPositionsChanged)
        || this.invoice.isBranch;
    },
    /**
     * @description Показать диалог изменения способа оплаты для операции по счету.
     */
    isShownChangePaymentModeForInvoiceOperationDialog() {
      return this.paymentOperationForChangeMode !== null;
    },
    /**
     * @description Предотвращать уход со страницы.
     * @type {boolean}
     */
    needPreventLeave() {
      return this.isAwaitCommandExecuted && this.isAwaitRequest;
    },
    /**
     * @description Нужна открытая смена.
     * @returns {boolean}
     */
    needOpenedShift() {
      return this.actions.includes(ACTION_CHECK_SHIFT_STATE);
    },
    /**
     * @description Врач изменен.
     * @type {boolean}
     */
    isEmployeeChanged() {
      const invoiceEmployeeId = this.invoice.fold(null)(({ employee }) => employee.id);
      return this.selectedEmployeeId !== invoiceEmployeeId;
    },
    /**
     * @description Идет получение данных.
     * @type {boolean}
     */
    isLoading() {
      return this.isAwaitLoading && this.invoice.isNone();
    },
    /**
     * @description Показывать кнопку сохранения.
     * @type {boolean}
     */
    isShowSaveButton() {
      return this.isChanged;
    },
    /**
     * @description Деактивировать оплату.
     * @type {boolean}
     */
    disabledPayment() {
      return this.isAwaitCommandExecuted
        || this.isChanged
        || this.invoiceDebt === 0
        || this.isAwaitRequest
        || this.isBranch;
    },
    /**
     * @description Деактивировать возврат.
     * @type {boolean}
     */
    disabledRefund() {
      return this.isAwaitCommandExecuted
        || this.isChanged
        || this.isAwaitRequest
        || this.initialPositionsForRefundList.length === 0
        || this.isBranch;
    },
    /**
     * @description Деактивировать выбор врача.
     * @type {boolean}
     */
    disableDoctorChange() {
      return this.invoiceDebt === 0;
    },
    /**
     * @description Операции по счету.
     */
    operationList() {
      return this.invoice.fold(null)(({ operationList }) => operationList);
    },
    /**
     * @description Оплачено.
     * @type {number}
     */
    paid() {
      return this.invoice.fold(0)(({ paid }) => paid);
    },
    /**
     * @description Оплаченная сумма без перерасчетов.
     * @type {number}
     */
    paymentAmount() {
      return this.invoice.fold(0)(({ paymentAmount }) => paymentAmount);
    },
    /**
     * @description Детали оплаты.
     * @type {object}
     */
    paymentDetails() {
      return this.invoice.fold({})((invoice) => ({
        advance: invoice.paymentAdvance,
        cash: invoice.paymentCash,
        cashless: invoice.paymentCashless,
      }));
    },
    /**
     * @description Текст при наведении на кнопку оплаты.
     * @returns {string}
     */
    paymentButtonTitle() {
      if (this.isChanged) {
        return 'Сначала сохраните изменения';
      }
      if (this.isAwaitCommandExecuted) {
        return 'Дождитесь завершения выполнения команды';
      }
      return '';
    },
    title() {
      return this.invoice.fold('')(({ title }) => title);
    },
    visit() {
      return this.invoice.fold(null)(({ visit }) => visit);
    },
    hasVisit() {
      if (this.visit) {
        return this.visit.id !== null;
      }
      return false;
    },
    /**
     * @description Позиции изменены.
     * @type {boolean}
     */
    isPositionsChanged() {
      return this.initialPositionsState !== this.calcPositionMomentState(this.positions);
    },
  },
  created() {
    const onSuccess = ({ employees, services }) => {
      this.employees = employees;
      this.services = services;
    };
    const onFail = (error) => {
      this.notifyFail(error.getTitle());
    };
    this.fetchTableSettings(TABLE_ID);
    this.fetchInvoiceables(this.patientId).then((result) => result.fold(onFail, onSuccess));
    this.fetchInvoice(this.invoiceId);
    this.fetchCashboxesList();
  },
  data() {
    return {
      /**
       * @description Действия.
       * @type {string[]}
       */
      actions: [],
      /**
       * @description Детализация аванса.
       * @type {({columns: string[], rows: any[], invoiceIds: string[]}|null)}
       */
      advanceDetails: null,
      /**
       * @description Доступные способы оплаты для смены.
       * @type {object[]}
       */
      availablePaymentModesForChanging: [],
      /**
       * @description Текущая операция.
       * @type {Maybe<string>}
       */
      currentOperation: Maybe.none(),
      /**
       * @description Сотрудник.
       * @type {any}
       */
      employee: null,
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Счет.
       * @type {Maybe}
       */
      invoice: Maybe.none(),
      /**
       * @description Документы счета.
       * @type {any[]}
       */
      invoiceDocuments: [],
      /**
       * @description Ожидание выполнения запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Ожидание выполнения принудительного проведения оплаты.
       * @type {boolean}
       */
      isAwaitForcePayment: false,
      /**
       * @description Счет является филиальным.
       * @type {boolean}
       */
      isBranch: false,
      /**
       * @description Показывать форму оплаты.
       * @type {boolean}
       */
      isShownPaymentForm: false,
      /**
       * @description Показывать форму возврата.
       * @type {boolean}
       */
      isShownRefundForm: false,
      /**
       * @description Показывать диалог подтверждения оплаты.
       * @type {boolean}
       */
      shownPaymentConfirmDialog: false,
      /**
       * @description Показывать диалог подтверждения ухода.
       * @type {boolean}
       */
      isShownDialogLeaveConfirm: false,
      /**
       * @description Начальный снимок состояния позиций.
       * @type {string}
       */
      initialPositionsState: '',
      /**
       * @description Счет сохранен.
       * @type {boolean}
       */
      isSaved: false,
      /**
       * @description Идентификатор команды оплаты.
       * @type {(number|null)}
       */
      paymentCommandId: null,
      /**
       * @description Операция изменения способа оплаты.
       * @type {(object|null)}
       */
      paymentOperationForChangeMode: null,
    };
  },
  methods: {
    /**
     * @description Обновить комментарий счёта.
     *
     * @returns {void}
     */
    onUpdateInvoiceComment() {
      this.setInvoiceComment();
    },
    /**
     * @description Распечатать квитанцию.
     * @param {any} response
     * @returns {void}
     */
    printSlip(response) {
      const blob = new Blob([response], { type: 'text/html' });
      const container = this.$refs.printView;
      container.setAttribute('src', URL.createObjectURL(blob));
      container.onload = () => {
        container.contentWindow.print();
      };
    },
    /**
     * @description Обработать печать акта.
     * @param {string} dateFrom
     * @param {string} dateTo
     * @returns {void}
     */
    onPrintAct(dateFrom, dateTo) {
      this
        .$patientGateway
        .formMutualSettlementsAct(this.patientId, dateFrom, dateTo)
        .then((result) => result.fold(this.notifyFail, this.printSlip));
    },
    /**
     * @description Установить комментарий счёта.
     * @return {void}
     */
    setInvoiceComment() {
      const request = new SetInvoiceCommentRequest(
        this.invoiceComment,
        this.invoiceId,
      );
      const onSuccess = ({ message }) => {
        this.notifySuccess(message);
      };
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      this.isAwaitRequest = true;
      return this.$invoiceGateway
        .setInvoiceComment(request)
        .then((result) => {
          result.forEach(onSuccess);
          result.forEachLeft(onFail);
          return result;
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Снять текущее состояние позиций в строку.
     * @param {Position[]} positions Позиции.
     * @returns {string}
     */
    calcPositionMomentState(positions) {
      const items = positions.map((item) => ({
        byVHIPolicy: item.byVHIPolicy,
        cost: item.cost,
        count: item.count,
        complaint: item.complaint,
        discount: item.discount.getMeaningfulFields(),
        serviceId: item.serviceId,
      }));
      return JSON.stringify(items);
    },
    waitCheckPrinted(commandId) {
      const { invoiceId } = this;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        if (result.status === STATUS_FAIL) {
          this.notifyFail(result.message);
          this.isAwaitForcePayment = false;
        } else {
          this.notifySuccess('Чек получен');
          this.fetchInvoice(invoiceId);
        }
      };
      this.waitExecuted(commandId)
        .then(onSuccess, onFail)
        .finally(() => {
          this.isAwaitCommandExecuted = false;
        });
    },
    /**
     * @description Получить счет.
     * @type {number} invoiceId Идентификатор счета.
     * @returns {void}
     */
    fetchInvoice(invoiceId) {
      const onSuccess = (invoice) => {
        this.invoice = Maybe.some(invoice);
        if (invoice.commandId) {
          this.paymentCommandId = invoice.commandId;
          this.waitCheckPrinted(invoice.commandId);
        } else {
          this.paymentCommandId = null;
        }
        this.actions = invoice.actions;
        this.tableColumns = invoice.columns;
        this.cashboxListPayment = invoice.cashboxesForPayment;
        this.employee = invoice.employee;
        this.positions = invoice.positions;
        this.selectedEmployeeId = invoice.employee.id;
        this.positionsForPaymentList = invoice.positionsForPayments;
        this.initialPositionsForRefundList = invoice.positionsForRefund;
        this.isBranch = invoice.isBranch;
        this.inputErrors = {};
        this.invoiceComment = invoice.comment;
        this.invoiceDocuments = invoice.documents;
        this.initialPositionsState = this.calcPositionMomentState(this.positions);
        if (this.needShownPrepayDialog) {
          this.suggestPrepay = false;
          this.prepayAmount = this.maxAmountForPrepay;
          this.shownPrepayDialog = true;
        }
        if (invoice.discountType !== DISCOUNT_MIXED) {
          this.discountType = invoice.discountType;
        }
        this.preselectDefaultCashbox();
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this.isSaved = false;
      this.isAwaitLoading = true;
      this.$invoiceGateway
        .viewById(invoiceId)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isAwaitLoading = false;
          this.isAwaitForcePayment = false;
        });
    },
    /**
     * @description Отправить запрос на редактирование.
     * @param {number} invoiceId
     * @returns {Promise<Either>}
     */
    sendEditRequest(invoiceId) {
      const onSuccess = ({ message }) => {
        this.isSaved = true;
        this.notifySuccess(message);
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const request = new EditRequest(this.selectedEmployeeId, invoiceId, this.positions);
      this.isAwaitRequest = true;
      return this.$invoiceGateway
        .edit(request)
        .then((result) => {
          result.forEach(onSuccess);
          result.forEachLeft(onFail);
          return result;
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать принудительное создание оплаты.
     * @returns {void}
     */
    onForcePayment() {
      if (!this.paymentCommandId) {
        return;
      }
      this.isAwaitForcePayment = true;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.isAwaitForcePayment = false;
      };
      this
        .$invoiceGateway
        .forcePayment(this.paymentCommandId)
        .then((result) => result.forEachLeft(onFail))
        .catch(() => {
          this.isAwaitForcePayment = false;
        });
    },
    /**
     * @description Обработать сохранение.
     * @returns {void}
     */
    onSubmit() {
      const { invoiceId } = this;
      const onSuccess = () => {
        this.fetchInvoice(invoiceId);
      };
      this.sendEditRequest(invoiceId).then((result) => result.forEach(onSuccess));
    },
    /**
     * @description Показать диалог оплаты.
     * @returns {void}
     */
    showPaymentForm() {
      this.preselectDefaultCashbox(true);
      this.isShownPaymentForm = true;
    },
    /**
     * @description Показать диалог возврата.
     * @returns {void}
     */
    showRefundForm() {
      this.currentOperation = Maybe.some(OPERATION_REFUND);
      this.continueOperation();
    },
    /**
     * @description Продолжить операцию.
     * @returns {void}
     */
    continueOperation() {
      this.currentOperation.forEach((operation) => {
        if (operation === OPERATION_PAY) {
          this.isShownPaymentForm = true;
        } else if (operation === OPERATION_RECHARGE) {
          this.openAdvanceRechargeForm();
        } else if (operation === OPERATION_REFUND) {
          this.isShownRefundForm = true;
        }
      });
      this.currentOperation = Maybe.none();
    },
    /**
     * @description Обработать отмену показа для детализации аванса.
     * @returns {void}
     */
    onAdvanceDetailsCancel() {
      this.advanceDetails = null;
    },
    /**
     * @description Обработать открытие детализации аванса.
     * @returns {void}
     */
    onAdvanceDetailsOpen() {
      this
        .$invoiceGateway
        .viewPatientAdvanceDetails(this.patientId)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach((details) => {
            this.advanceDetails = details;
          });
        });
    },
    /**
     * @description Обработать отмену изменения способа оплаты для операции по счету.
     * @param {boolean} needsShown Нужно показывать.
     * @returns {void}
     */
    onCancelChangePaymentModeForInvoiceOperation(needsShown) {
      this.paymentOperationForChangeMode = needsShown
        ? this.paymentOperationForChangeMode
        : null;
    },
    /**
     * @description Обработать изменения способа оплаты для операции со счетом.
     * @param {string} operationId Идентификатор операции.
     * @returns {void}
     */
    onChangePaymentModeForInvoiceOperation(operationId) {
      this
        .$invoiceGateway
        .viewPaymentModeChangeForInvoiceOperation(operationId)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ availableModes, paymentOperation }) => {
            this.availablePaymentModesForChanging = availableModes;
            this.paymentOperationForChangeMode = paymentOperation;
          });
        });
    },
    /**
     * @description Обработать отмену оплаты.
     * @returns {void}
     */
    onPaymentCancel() {
      this.isShownPaymentForm = false;
      this.paymentAmountToPaid = 0;
    },
    /**
     * @description Обработать печать квитанции об оплате.
     * @param {number} operationId
     * @returns {void}
     */
    onPrintPaymentSlip(operationId) {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$invoiceGateway
        .printPaymentSlip(operationId)
        .then((result) => result.fold(onFail, this.printSlip));
    },
    /**
     * @description Обработать печать квитанции возврата.
     * @param {number} operationId
     * @returns {void}
     */
    onPrintRefundSlip(operationId) {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$invoiceGateway
        .printRefundSlip(operationId)
        .then((result) => result.fold(onFail, this.printSlip));
    },
    /**
     * @description Обработать показ диалога подтверждения оплаты.
     * @returns {void}
     */
    onShownConfirmDialog(value) {
      this.shownPaymentConfirmDialog = value;
    },
    /**
     * @description Обработать клин вне формы.
     * @returns {void}
     */
    onClickOutside() {
      if (!this.shownPaymentConfirmDialog) {
        this.onPaymentCancel();
      }
    },
    /**
     * @description Обработать отмену возврата.
     * @returns {void}
     */
    onRefundCancel() {
      this.isShownRefundForm = false;
    },
    /**
     * @description Обработать оплату.
     * @param {PayRequest} request Запрос.
     * @returns {void}
     */
    onPay(request) {
      const onFail = (error) => {
        if (error.hasCauses()) {
          this.shownPaymentConfirmDialog = false;
        }
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        this.inputErrors = {};
        this.notifySuccess(result.message);
        if (result.command_id) {
          this.paymentCommandId = result.command_id;
          this.waitCheckPrinted(result.command_id);
        } else {
          this.fetchInvoice(this.invoiceId);
        }
        this.paymentAmountToPaid = 0;
        this.isShownPaymentForm = false;
        this.shownPaymentConfirmDialog = false;
        this.onSelectPositionForPaidPaid();
      };
      this.isAwaitRequest = true;
      this.$invoiceGateway
        .pay(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать возврат.
     * @param {PayRequest} request Запрос.
     * @returns {void}
     */
    onRefund(request) {
      const onFail = (error) => {
        if (error.hasCauses()) {
          this.shownPaymentConfirmDialog = false;
        }
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        this.inputErrors = {};
        this.notifySuccess(result.message);
        if (result.command_id) {
          this.waitCheckPrinted(result.command_id);
        } else {
          this.fetchInvoice(this.invoiceId);
        }
        this.isShownRefundForm = false;
        this.shownPaymentConfirmDialog = false;
        this.onSelectPositionForRefundRefund();
      };
      this.isAwaitRequest = true;
      this.$invoiceGateway
        .refundManualCashbox(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать отправку изменения способа оплаты для операции по счету.
     * @param {string} mode Способ оплаты.
     * @returns {void}
     */
    onSubmitChangePaymentModeForInvoiceOperation(mode) {
      this
        .$invoiceGateway
        .changePaymentModeForInvoiceOperation(
          this.paymentOperationForChangeMode.id,
          mode,
        )
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ title }) => {
            this.fetchInvoice(this.invoiceId);
            this.onCancelChangePaymentModeForInvoiceOperation(false);
            this.notifySuccess(title);
          });
        });
    },
    /**
     * @description Подтвердить предупреждение.
     * @returns {void}
     */
    confirmAttention() {
      this.isShownDialogLeaveConfirm = false;
    },
  },
  mixins: [
    actDocumentPrint,
    cashboxMixin,
    customizableTableMixin,
    notifierMixin,
    invoiceMixin,
    onlineCheckMixin,
    prepayMixin,
    rechargeMixin,
    selectPositionForPaidMixin,
    selectPositionForRefundMixin,
    shiftMixin,
    preventLeaveWithoutConfirmMixin,
    mobilePopupMixin,
    mobileMixin,
    withdrawalMixin,
  ],
  name: 'ClinicPanelPatientInvoice',
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.patient-profile {
  &__table-wrapper {
    overflow-x: scroll;
  }
}

.form-advance-withdrawal-dialog {
  & &__body {
    margin-top: 1.5rem;
  }
}

.text__violation {
  color: var(--warning-color);
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  padding: 0.125rem;
}

.form-invoice {
  &__control{
    display: grid;
    grid-template-columns: 1fr 2fr;
    align-items: start;
    gap: 20px 40px;
    margin-top: 20px;
    &__employee {
      display: flex;
      align-items: center;
      gap: 5px 20px;
      font-size: 18px;
      line-height: 21px;
      &__select {
        max-width: 356px;
        margin: 0;
        padding: 0;
      }
    }
    &__comment {
      display: flex;
      align-items: center;
      gap: 5px 20px;
      font-size: 18px;
      line-height: 21px;
      &__description {
        align-self: flex-start;
        margin-top: 15px;
      }
      &__input {
        width: min(100%, 1000px);
      }
    }
    &__row {
      display: flex;
      flex-flow: row wrap;
      gap: 10px 17px;
      margin-top: 20px;
    }
    &__visit {
      color: var(--action-color);
      text-decoration: none;
      font-size: 18px;
      line-height: 21px;
      border-bottom: 1px dashed transparent;
      &:hover {
        border-bottom: 1px dashed var(--action-color);
      }
    }
  }
  &__form-buttons {
    display: grid;
    margin-top: 25px;
    justify-content: flex-end;
    column-gap: 17px;
    grid-template-columns: repeat(auto-fit, 179px);
  }
  &__text {
    font-size: 18px;
    line-height: 21px;
    color: #192A3E;
  }
}
.invoice {
  &__print {
    display: none;
  }
  &__confirm-dialog {
    min-width: 300px;
    &__buttons {
      margin-top: 20px;
      display: flex;
      gap: 8px;
    }
    &__button-cancel {
      @include buttons.btn-transparent(100%, 48px, 1fr);
    }
    &__button-submit {
      @include buttons.btn-blue(100%, 48px, 1fr);
      &:disabled {
        background-color: var(--unfocus-color);
        border: 1px solid var(--unfocus-color);
        color: white;
      }
    }
  }
  &__operations {
    &__refund {
      color: var(--action-color);
      text-decoration: underline;
      text-decoration-style: dashed;
      &:hover {
        text-decoration-style: solid;
      }
    }
    &__table {
      counter-reset: counterOperations;
      margin: 25px 0 0 0;
      &__head,
      &__row {
        display: grid;
        grid-template-columns: 40px 140px 140px 1fr 92px 147px;
        width: 100%;
        align-items: center;
        font-size: 14px;
        line-height: 17px;
      }
      &__head {
        font-weight: 700;
        border-bottom: 2px solid #0489e0;
      }
      &__row {
        text-align: left;
        border-bottom: 1px solid #eaeff3;
        cursor: default;
        &:hover {
          background: #eaeff3;
          .invoice__operations__table__cell {
            background: #eaeff3;
          }
        }
      }
      &__cell {
        transition: color var(--animate-duration);
        padding: 12px 8px;
        display: flex;
        align-items: center;
        &.number:after {
          counter-increment: counterOperations;
          content: counter(counterOperations);
        }
        &.delete {
          display: block;
          background-image: url("@/assets/img/exit-grey.svg");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          width: 12px;
          height: 12px;
          cursor: pointer;
          &:hover {
            background-image: url("@/assets/img/exit-blue.svg");
          }
        }
      }
    }
  }
  &__check-preview {
    width: 100%;
    &__check {
      margin-top: 10px;
      &__position {
        display: grid;
        column-gap: 10px;
        grid-template-columns: 1fr 120px 120px;
      }
    }
  }
  &__prepay-dialog {
    color: var(--reading-color);
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    &__buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
      width: 100%;
      margin: 20px 0 0 0;
    }
    &__button-cancel {
      @include buttons.btn-transparent(100%, 44px, 16px);
    }
    &__button-submit {
      @include buttons.btn-blue(100%, 44px, 16px);
      &:disabled {
        background-color: var(--unfocus-color);
        border: 1px solid var(--unfocus-color);
        color: white;
      }
    }
  }
  &__title {
    margin-top: 10px;
  }
  &__document {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
    &__buttons {
      width: 100%;
      display: flex;
      gap: 10px;
    }
    &__button {
      @include buttons.btn-blue(100%, 32px, 12px);
      max-width: 150px;
      &:disabled {
        background-color: var(--unfocus-color);
      }
    }
    &__count {
      input {
        border-bottom: 1px solid #C2CFE0;
        box-sizing: border-box;
        appearance: textfield;
        text-align: center;
        height: 30px;
        width: 30px;
        margin: 0 7px;
        color: #707683;
        font-size: 14px;
        &:focus {
          color: #192a3e;
          background-color: #fff;
          border-bottom: 1px solid #0489e0 !important;
          outline: 0;
        }
        &:disabled {
          background-color: #fff;
        }
      }
    }
    &__date {
      input {
        border-bottom: 1px solid #C2CFE0;
        box-sizing: border-box;
        appearance: textfield;
        text-align: center;
        height: 30px;
        width: 120px;
        margin: 0 7px;
        color: #707683;
        font-size: 14px;
        &:focus {
          color: #192a3e;
          background-color: #fff;
          border-bottom: 1px solid #0489e0 !important;
          outline: 0;
        }
        &:disabled {
          background-color: #fff;
        }
      }
    }
  }
}

.form-select {
  color: #212529;

  &__buttons {
    width: 100%;
    // margin-top: 10px;
    display: grid;
    grid-template-columns: 226px 226px;
    justify-content: center;
    column-gap: 10px;
  }

  &__button {
     &-cancel {
      @include buttons.btn-transparent(100%, 44px, 16px);
    }
    &-submit {
      @include buttons.btn-blue(100%, 44px, 16px);
      &:disabled {
        background-color: var(--unfocus-color);
        border: 1px solid var(--unfocus-color);
        color: white;
      }
    }
  }

  &__table {
    counter-reset: counterServices;
    margin: 25px 0 0 0;
    &__head,
    &__row {
      display: grid;
      grid-template-columns: 40px 1fr 160px 100px 100px 90px 130px;
      width: 100%;
      align-items: center;
      font-size: 14px;
      line-height: 17px;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
    }
    &__row {
      text-align: left;
      border-bottom: 1px solid #eaeff3;
      &:hover {
        background: #eaeff3;
      }
    }
    &__cell {
      transition: color var(--animate-duration);
      padding: 12px 8px;
      display: flex;
      align-items: center;

      &.checkbox {
        justify-self: center;
        transform: translateY(2px);
        & span::before {
          margin: 0 !important;
        }
        ::v-deep input:disabled + span.checkbox__title {
          cursor: inherit !important;
        }
      }
    }
  }

  &__sum {
    display: grid;
    grid-template-columns: 125px minmax(100px, 130px);
    align-items: center;
    margin-top: 10px;
    font-size: 16px;
    &-wrapper {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    &__field {
      padding: 5px;
      min-width: 60px;
      max-width: 125px;
      height: 31px;
      border: 1px solid #0489e0;
      border-radius: 4px;
      &:hover {
        cursor: text;
      }
    }
  }
}

.operations-table {
  border-collapse: collapse;
  font-size: .875rem;
  line-height: 1rem;
  overflow: auto;
  table-layout: fixed;
  width: 100%;
  min-width: 600px;
  & &__body-row {
    border-bottom: 1px solid var(--fill-color);
  }
  & &__caption {
    font-size: 1.125rem;
    margin: 1rem 0 .5rem 0;
    text-align: left;
  }
  & &__cell {
    padding: 15px 8px;
    text-align: left;
    text-transform: none;
    white-space: pre-line;
  }
  & &__cell.actions {
    text-align: right;
    button+button {
      margin-left: 5px;
    }
  }
  & &__head {
    border-bottom: 2px solid var(--action-color);
    font-weight: 700;
  }
}

.payment-mode-change {
  background: center / contain no-repeat url("@/assets/img/pen-grey.svg");
  font-size: 0;
  height: 14px;
  width: 14px;
  &:hover {
    background-image: url("@/assets/img/pen-blue.svg");
  }
}

.payment-slip-print {
  background: center / contain no-repeat url("@/assets/img/print-grey.svg");
  font-size: 0;
  height: 14px;
  width: 14px;
  &:hover {
    background-image: url("@/assets/img/print.svg");
  }
}

@media screen and (max-width: 1080px) {
  .form-invoice {
    &__control {
      grid-template-columns: 1fr;
    }
  }
  .form-invoice__form-buttons {
    grid-template-columns: repeat(2, minmax(150px, 180px));
    row-gap: 10px;
    &--show-print {
      grid-template-columns: 1.2fr 0.8fr 0.8fr;
    }
  }
}

@media screen and (max-width: 880px) {
  .form-select {
    &__table {
      &__head {
        display: none;
      }
      &__row {
        grid-template-columns: 1fr;
        grid-gap: 5px;
        margin: 0 0 20px 0;
      }
      &__cell {
        display: flex;
        justify-content: space-between;
        text-align: right;
        &.checkbox, &.payment {
          justify-self: auto;
        }
        &.name {
          .v-select__slot > input {
            text-align: right;
          }
        }
        &.number > input {
          text-align: right;
        }
      }
      &__cell:before {
        content: attr(data-label);
        font-weight: 700;
        margin-right: 20px;
        white-space: nowrap;
      }
    }
  }
}

@media screen and (max-width: 580px) {
  .form-select {
    &__buttons {
      grid-template-columns: 1fr;
      row-gap: 10px;
    }
  }
  .operations-table {
    width: auto;
  }
}

@media screen and (max-width: 480px) {
  .form-invoice {
    &__form-buttons {
      grid-template-columns: repeat(2, minmax(140px, 0.8fr));
    }
    &__buttons-print {
      display: none;
    }
    &__employee {
      flex-direction: column;
      align-items: flex-start;
      &__select {
        max-width: 100%;
        width: 100%;
      }
    }
  }
  .invoice__operations__table {
    &__head {
      display: none;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 5px;
      margin: 0 0 20px 0;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
    }
    &__cell:before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
    }
    &__controls {
      grid-template-columns: 1fr;
      row-gap: 10px;
      &__aggregate {
        grid-column: 1;
        width: 100%;
        &__rub {
          text-align: right;
        }
      }
    }
  }
}
</style>
